/**
 * Where the Issues pages remember their filter selections (see
 * `usePersistedIssueFilters`). Kept apart from the hook so sign-out can clear
 * them without pulling PM code into the auth store.
 */
export const ISSUE_FILTERS_STORAGE_PREFIX = "franklin:pm-issue-filters:";

/**
 * Forget every remembered issue selection in this browser. Called on sign-out:
 * the keys are per user, but the entries name other people (assignee ids) and
 * hold free-text searches, which should not outlive the session on a shared
 * device.
 */
export function clearPersistedIssueFilters(): void {
  try {
    const keys: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i);
      if (k?.startsWith(ISSUE_FILTERS_STORAGE_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => window.localStorage.removeItem(k));
  } catch {
    // Storage unreadable: there is nothing persisted to remove.
  }
}
